export const routes = {
  HOME: "/",
  ABOUT: "/about",
  CONTACT: "/contact",
  PROJECTS: "/projects",
};
